import React from 'react';

interface KeyHoleProps {
  className?: string;
  size?: number;
}

const KeyHole: React.FC<KeyHoleProps> = ({ className = "", size = 20 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    className={className}
    width={size}
    height={size}
  >
    <path
    stroke="currentColor"
    strokeWidth={1}
    fillRule="evenodd"
    d="M2.052 3.503a.5.5 0 0 0-.104.994c4.57.475 9.22 2.738 11.869 6.742-.5.76-.817 1.64-.817 2.603a1 1 0 0 0 .916.997l.018.002a1.4 1.4 0 0 1 .372.098.6.6 0 0 1 .099.052c-.003.934-.137 2.144-.312 2.843a1 1 0 0 0 .351 1.029c-2.04 7.199-6.878 13.465-12.719 17.307a.5.5 0 1 0 .55.835C8.34 33.015 13.356 26.5 15.444 19.002a1 1 0 0 0 .59-.683c.226-.904.372-2.308.372-3.37 0-1.081-.792-1.62-1.29-1.839.213-.676.71-1.337 1.443-1.898.99-.76 2.256-1.212 3.347-1.212 1.089 0 2.334.451 3.303 1.207.823.642 1.347 1.42 1.489 2.207l-.084.07c-.27.228-.59.495-.825.679a1 1 0 0 0-.383.787c0 1.04.116 2.457.379 3.396a1 1 0 0 0 .81.72c2.275 7.473 6.816 13.83 13.132 17.943a.5.5 0 1 0 .546-.838c-6.121-3.986-10.539-10.168-12.744-17.47a1 1 0 0 0 .182-.893c-.162-.579-.268-1.528-.297-2.387a52 52 0 0 0 .834-.7l.103-.088.028-.024.008-.007.001-.002h.001l-.261-.303.261.303a1 1 0 0 0 .348-.758c0-.878-.26-1.687-.679-2.401 2.381-3.677 5.873-6.55 11.973-6.927a.5.5 0 1 0-.062-.999c-6.293.39-10.017 3.32-12.536 7.058a7 7 0 0 0-.994-.943C23.16 8.633 21.49 8 19.906 8s-3.27.631-4.565 1.625a7 7 0 0 0-.874.791C11.592 6.28 6.745 3.99 2.052 3.503"
    />

  </svg>
);

export default KeyHole;
